import styled from "styled-components";

export const BotReferralContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 20px;
  width: 100%;

  .text-muted {
    margin-bottom: 0px !important;
  }
`

export const MainHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  align-self: center;

  width: 100%;
  max-width: 1600px;
  padding: 20px;
  margin-top: 30px;
  gap: 20px;

  background: #192619;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 15px;
    margin-top: 20px;
  }
`

export const SecondaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  align-self: center;

  width: 100%;
  max-width: 1600px;
  padding: 20px;
  margin-top: 30px;
  gap: 20px;

  background: #192619;
  border-radius: 10px;

  @media (max-width: 768px) {
    padding: 15px;
    margin-top: 20px;
  }
`

export const Title = styled.h1`
  font-family: 'Montserrat';
  font-weight: bold;
  letter-spacing: -0.04em;
  width: 100%;
  font-size: 30px;
  align-self: flex-start;
`;

export const TopSection = styled.div`
  display: flex;
  width: 100%;
  gap: 40px;
  align-items: center;
  background-color: #111e12;
  border-radius: 14px;
  padding: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }
`

export const ReferralImage = styled.img`
  width: 250px;
  height: 250px;
  object-fit: contain;

  @media (max-width: 768px) {
    width: 180px;
    height: 180px;
  }
`

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 40px;
  width: 100%;
`;

export const StatsSection = styled.div`
  display: flex;
  gap: 30px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const StatBox = styled.div`
  background: #1C2D1C;
  border-radius: 12px;
  padding: 45px 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 25px;
  flex: 1;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 30px 20px;
  }
`;

export const StatIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
    width: 80px;
    height: 80px;
    object-fit: contain;

    @media (max-width: 768px) {
      width: 48px;
      height: 48px;
    }
  }
`;

export const StatContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
`;

export const StatLabel = styled.div`
  font-size: 20px;
  color: #758B78;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: -0.024em;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const StatValue = styled.div`
  font-size: 38px;
  font-weight: bold;
  color: ${props => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 32px;
  }
`;

export const ReferralLink = styled.div`
  width: 100%;
  background: #111e12;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 15px;
    gap: 15px;
  }
`;

export const LinkInput = styled.input`
  flex: 1;
  background: #1d2d1d;
  border: none;
  padding: 15px 20px;
  border-radius: 10px;
  color: #fff;
  font-size: 16px;
  outline: none;

  @media (max-width: 768px) {
    width: 100%;
    padding: 12px 15px;
    font-size: 14px;
  }
`;

export const ShareButton = styled.button`
  background: #96CE4E;
  color: #111e12;
  border: none;
  padding: 15px 40px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 12px 20px;
    font-size: 14px;
  }
`;

export const RewardText = styled.div`
  color: #94a3b8;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 8px;

  span {
    color: #38bdf8;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    justify-content: center;
  }
`;

export const ExplainerSection = styled.div`
  background: #111e12;
  border-radius: 12px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const ExplainerTitle = styled.h2`
  font-family: 'Montserrat';
  font-weight: bold;
  font-size: 24px;
  color: #fff;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

export const ExplainerText = styled.div`
  color: white;
  font-size: 16px;
  line-height: 1.5;
  white-space: pre-line;

  strong {
    color: #96CE4E;
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const ExplainerCTA = styled.button`
  background: #96CE4E;
  color: #111e12;
  border: none;
  padding: 15px 40px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: opacity 0.2s;
  align-self: flex-start;

  &:hover {
    opacity: 0.9;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 12px 20px;
    font-size: 14px;
  }
`;

export const FAQSection = styled.div`
  background: #111e12;
  border-radius: 12px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const FAQTitle = styled.h2`
  font-family: 'Montserrat';
  font-weight: bold;
  font-size: 24px;
  color: #fff;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

export const FAQItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
`;

export const FAQQuestion = styled.h3`
  font-family: 'Montserrat';
  font-weight: 600;
  font-size: 18px;
  color: #96CE4E;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;

  &::after {
    content: '▼';
    font-size: 14px;
    transition: transform 0.3s ease;
    transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0)'};
  }

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const FAQAnswer = styled.p`
  color: white;
  font-size: 16px;
  line-height: 1.5;
  margin: 0;
  max-height: ${props => props.isOpen ? '500px' : '0'};
  overflow: hidden;
  transition: all 0.3s ease;
  opacity: ${props => props.isOpen ? '1' : '0'};
  padding: ${props => props.isOpen ? '10px 0' : '0'};

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;